import { Scene, Camera, PlaneGeometry, RawShaderMaterial, Mesh, Color, Vector2 } from "three";

import Common from "./Common";
import Simulation from "./Simulation";
import face_vert from "./glsl/sim/face.vert";
import color_frag from "./glsl/sim/color.frag";
import Experience from "../Experience";


export default class Output{
    constructor(){
        this.experience = Experience.getInstance();
        this.common = Common.getInstance()
        this.init();
    }

    init(){
        this.simulation = new Simulation();
        this.scene = new Scene();
        this.camera = new Camera();

        this.output = new Mesh(
            new PlaneGeometry(2, 2),
            new RawShaderMaterial({
                depthWrite: false,
                depthTest: false,
                vertexShader: face_vert,
                fragmentShader: color_frag,
                uniforms: {
                    velocity: {
                        value: this.simulation.fbos.vel_0.texture
                    },
                    clearColor: { value: new Color(0x111111).convertSRGBToLinear() },
                    boundarySpace: {
                        value: new Vector2()
                    }
                },
            })
        );

        this.scene.add(this.output);
    }

    resize(){
        this.simulation.resize();
    }

    render(){
        this.common.renderer.setRenderTarget(this.common.renderTarget);
        this.common.renderer.autoClear = false;
        this.common.renderer.render(this.scene, this.camera);
        this.common.renderer.setRenderTarget(null);
    }

    update(){
        this.simulation.update();
        this.render();
    }

    destroy() {
        // Dispose of Three.js objects
        if (this.output) {
            if (this.output.geometry) this.output.geometry.dispose();
            if (this.output.material) {
                if (this.output.material.uniforms.velocity.value) {
                    this.output.material.uniforms.velocity.value.dispose();
                }
                this.output.material.dispose();
            }
        }

        if (this.scene) {
            this.scene.remove(this.output);
            // Dispose of all objects in the scene
            this.scene.traverse((object) => {
                if (object.geometry) object.geometry.dispose();
                if (object.material) object.material.dispose();
            });
        }

        // Clean up Simulation instance
        if (this.simulation) {
            this.simulation.destroy(); // Assuming Simulation has a destroy method
        }

        // Clear references
        this.experience = null;
        this.common = null;
        this.simulation = null;
        this.scene = null;
        this.camera = null;
        this.output = null;
    }
}
